module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_photowedding_02@3x-68be8737cfd21a36790210121a29749c.webp";